// extracted by mini-css-extract-plugin
export default {"container":"Home_container__uIm-s","header":"Home_header__iXky6","text":"Home_text__EJ0zz","subtitle":"Home_subtitle__A5ZY3","subsubtitle":"Home_subsubtitle__oBVuZ"};